export class Primitive {

    public Id: number = 0;
    public Name: string = "";
}
